module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title-head"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('table', [_c('colgroup', [_c('col', {
    attrs: {
      "width": "40px"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "350px"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Title",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Acknowledgements#Ack"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Introduction#Int"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#/Chapter01#C1"
    }
  }, [_vm._v("1.")])]), _c('td', [_c('a', {
    attrs: {
      "href": "#/Chapter01#C1"
    }
  }, [_vm._v("World Champions and International Hall of Famers")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter02#C2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter02#C2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("World Title Challengers")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter03#C3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter03#C3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("State and Regional Champions")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter04#C4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter04#C4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Local Heroes")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter05#C5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.")])]), _c('td', [_c('span', {
    attrs: {
      "href": "#/Chapter05#C5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Non-Boxers")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Pennsylvania#Penn",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pennsylvania Boxing Hall of Fame Inductees 1958–2023")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a3ddcc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 72
// module chunks = 0